import React, { useState, useCallback, useRef, useEffect } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import { Visible } from "../../core/components";

const getCroppedImg = (image, crop) => {
  const DEST_WIDTH = 450;
  const DEST_HEIGHT = 450;

  const canvas = document.createElement("canvas");
  const scaleX = (image?.naturalWidth || 0) / image.width;
  const scaleY = (image?.naturalHeight || 0) / image.height;
  canvas.width = DEST_WIDTH;
  canvas.height = DEST_HEIGHT;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    DEST_WIDTH,
    DEST_HEIGHT
  );

  const base64Image = canvas.toDataURL("image/jpeg");

  return base64Image;
};

const ImageCrop = ({ src, onCrop, onBeforeFileLoad, setImage }) => {
  const [upImg, setUpImg] = useState(null);
  const imgRef = useRef(null);
  const zoomRef = useRef(null);

  useEffect(() => {
    setUpImg(src);
  }, [src, setUpImg]);

  const onSelectFile = (e) => {
    onBeforeFileLoad(e);

    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setUpImg(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const getCropWidth = () => {
    return document.getElementById("cropArea").offsetWidth;
  };

  const onLoad = useCallback((img) => {
    const width = img.naturalWidth;
    const height = img.naturalHeight;
    const cropSize = getCropWidth();

    const imgEl = document.getElementById("crop-img");

    if (width < height) {
      imgEl.width = cropSize;
    } else {
      imgEl.height = cropSize;
    }

    imgRef.current = img;

    onCrop(
      getCroppedImg(imgRef.current, {
        x: 0,
        y: 0,
        width: cropSize,
        height: cropSize,
      })
    );
  }, []);

  const removeImge = useCallback(() => {
    setUpImg(null);
    setImage(null);
  }, [setUpImg]);

  const computeCrop = () => {
    const zoomState = zoomRef.current.state;
    const scale = zoomState.scale;
    const cropSize = getCropWidth();

    const crop = {
      x: (zoomState.positionX / scale) * -1,
      y: (zoomState.positionY / scale) * -1,
      width: cropSize / scale,
      height: cropSize / scale,
    };

    onCrop(getCroppedImg(imgRef.current, crop));
  };

  return (
    <div className="image-crop">
      <Visible when={!upImg}>
        <div className="choose-file">
          <input
            id="image-crop-file"
            className="hidden"
            type="file"
            accept="image/*"
            onChange={onSelectFile}
          />
          <label htmlFor="image-crop-file">Choose a file</label>
        </div>
      </Visible>
      <Visible when={upImg}>
        <div className="change-image" onClick={removeImge}>
          <svg viewBox="0 0 475.2 475.2" width="20px" height="20px">
            <g>
              <path
                d="M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6    s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7    s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7    C468.6,170.8,468.6,304.4,386.5,386.5z"
                fill="black"
              ></path>
              <path
                d="M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1    l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4    c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z"
                fill="black"
              ></path>
            </g>
          </svg>
        </div>

        <div className="crop-area" id="cropArea">
          <TransformWrapper
            initialScale={1}
            initialPositionX={0}
            initialPositionY={0}
            ref={zoomRef}
            limitToBounds={false}
            onWheelStop={() => computeCrop()}
            onPanningStop={() => computeCrop()}
            onPinchingStop={() => computeCrop()}
            onZoomStop={() => computeCrop()}
          >
            <TransformComponent
              wrapperStyle={{ width: "350px", height: "350px" }}
              contentStyle={{ width: "350px", height: "350px" }}
            >
              <img
                id="crop-img"
                src={upImg}
                onLoad={(e) => onLoad(e.currentTarget)}
              />
            </TransformComponent>
          </TransformWrapper>
          <div className="crop-selection"></div>
        </div>
      </Visible>
    </div>
  );
};

export default ImageCrop;
